import { Text, Tokens } from "@accurx/design";
import styled from "styled-components";

export const StyledSectionHeading = styled((props) =>
    Text({ ...props, variant: "label", as: "h2" }),
)`
    margin-bottom: ${Tokens.SIZES[1.5]};
`;
